import React from 'react'
import PropTypes from 'prop-types'

function CategoriesNone({ styling }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 986.09 986.09"
      className={styling}
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path d="M373.53,561.03H111.03c-19.9,0-39,7.9-53,22-14.1,14.1-22,33.1-22,53v262.5c0,19.9,7.9,39,22,53,14.1,14.1,33.1,22,53,22h262.5c19.9,0,39-7.9,53-22,14.1-14.1,22-33.1,22-53v-262.5c0-19.9-7.9-39-22-53-14.1-14.1-33.1-22-53-22Z" />
          <path d="M973.53,767.23c0-54.7-21.7-107.2-60.4-145.8-38.7-38.7-91.1-60.4-145.8-60.4h0c-37.47,0-73.9,10.19-105.54,29.04l282.69,282.69c18.86-31.65,29.05-68.05,29.05-105.53Z" />
          <path d="M448.63,373.53V111.03h-.1c0-19.9-7.9-38.9-22-53-14-14.1-33.1-22-53-22H111.03c-1.07,0-2.14.03-3.2.08l340.72,340.72c.05-1.1.08-2.2.08-3.3Z" />
          <polygon points="373.53 561.03 373.53 561.03 373.63 561.03 373.53 561.03" />
          <path d="M636.13,448.53h262.5c19.9,0,39-7.9,53-22,14.1-14.1,22-33.1,22-53V111.03c0-19.9-7.9-39-22-53-14.1-14.1-33.1-22-53-22h-262.5c-19.9,0-39,7.9-53,22-14.1,14.1-22,33.1-22,53v262.5c0,19.9,7.9,39,22,53,14.1,14.1,33.1,22,53,22Z" />
          <polygon points="944.47 872.76 661.78 590.06 448.54 376.83 107.82 36.11 71.72 0 40.53 31.18 954.91 945.56 986.09 914.37 944.47 872.76" />
          <path d="M0,71.72l36.11,36.11c-.05,1.07-.08,2.13-.08,3.2v262.5c0,19.9,7.9,38.9,22,53,14,14.1,33.1,22,53,22h262.6c1.04,0,2.07-.03,3.11-.08l213.37,213.37c-18.81,31.62-28.98,67.97-28.98,105.4,0,54.7,21.7,107.2,60.4,145.8,38.7,38.7,91.1,60.4,145.8,60.4,37.42,0,73.8-10.16,105.42-28.96l41.63,41.63,31.18-31.18,9.35-9.35L40.53,31.18,0,71.72Z" />
        </g>
      </g>
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
CategoriesNone.propTypes = {
  styling: string,
}

export default CategoriesNone
